import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services/http-common.service";
import { take } from "rxjs/operators";
import { AccountingDocumentFormComponent } from "../accounting-document-form/accounting-document-form.component";

export class ConfirmDateValue {
  EndDate: Date;
  StartDate: Date;
  closeDialog: Function;
  FiscalYearId: number;
}

@Component({
  selector: "ngx-accounting-document-list",
  templateUrl: "./accounting-document-list.component.html",
  styleUrls: ["./accounting-document-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountingDocumentListComponent extends BaseListComponent {
  gridColumns: form_control[];
  dataFilter: any;
  isAdd: boolean = true;
  @ViewChild("grid") public grid: KGridComponent;
  constructor(public cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super();
    this.inputEditorform = AccountingDocumentFormComponent;
  }

  async ngOnInit() {
    this.apiName = "AccVoucherHeader";
    this.areaName = "Accounting";
    this.label = this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.SendToBranch");
    this.GetSystemKindLookup();
    this.FillData();
  }

  async FillData() {
    if (this.accountService.authService?.currentBranch?.SendVoucherFromCenter) this.isAdd = false;
  }

  async GetSystemKindLookup() {
    await this.lookupservice
      .getLookupbyCategory("GNR", "SystemKind")
      .pipe(take(1))
      .subscribe((data) => {
        const findLookup = data.find((f) => f.Code == SystemKind.SALE);
        if (findLookup) {
          this.dataFilter = [
            {
              Filed: "SystemKindId",
              Value: findLookup.Id,
              Skip: 0,
              Take: 0,
              Operator: "eq",
              Type: "F",
            },
            {
              Filed: "BranchId",
              Value: this.accountService.authService.currentBranchId,
              Skip: 0,
              Take: 0,
              Operator: "eq",
              Type: "F",
            },
          ];
          this.cd.markForCheck();     
        }
      });
  }

  async DeleteAccVoucher($event) {
    this.sts.showDialog(
      `${this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.HasDeleteData")}`,
      this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.DeleteInformation"),
      DialogType.confirm,
      async () => {
        await this.httpCommonService
          .getList("CashierSettlemet/GetAccVoucher" + `/${$event.Id}`)
          .pipe(take(1))
          .toPromise()
          .then(
            (data: any[]) => {
              this.grid.refreshData();
            },
            (error) => {
              let errorMessage = Utilities.getHttpResponseMessage(error);
              if (errorMessage) {
                this.sts.showDialog(`${errorMessage}`, this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.ErrorMessage"));
              }
            }
          );
      }
    );
  }
}
